import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=c410719e&scoped=true&"
import script from "./Merchants.vue?vue&type=script&lang=js&"
export * from "./Merchants.vue?vue&type=script&lang=js&"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=c410719e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c410719e",
  null
  
)

export default component.exports